import { MetabaseParameterDateComponent } from './metabase-parameter/metabase-parameter-date/metabase-parameter-date.component';
import { Type } from '@angular/core';
import { MetabaseParameterFieldBase } from './metabase-parameter/metabase-parameter-field-base.interface';
import { MetabaseParameterTextComponent } from './metabase-parameter/metabase-parameter-text/metabase-parameter-text.component';

export const builtInPlugins: Type<MetabaseParameterFieldBase>[] = [MetabaseParameterDateComponent, MetabaseParameterTextComponent];
